// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"footer-module--socialLink--2t5Rz"};